//import { User } from "oidc-client";

import { User } from "oidc-client";


export interface Session {
    id_token: string;
    session_state: string;
    access_token: string;
    token_type: string;
    scope: string;
    profile: Profile;
}

export interface Profile {
    phone_number: string;
    email: string;
    given_name: string;
    userId: number;
    role: string;
}

export function createInitialState(): Session {
    return {} as Session;
}

export function createSessionFromUser(params: User): Session {
    return {
        id_token: params.id_token,
        session_state: params.session_state,
        access_token: params.access_token,
        token_type: params.token_type,
        scope: params.scope,
        profile: {
            phone_number: params.profile.phone_number,
            email: params.profile.email,
            given_name: params.profile.given_name,
            userId: params.profile.userId,
            role: params.profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
        },
    } as Session;
}
